<div class="popup-overlay" (click)="closePopup(emailForm, editorContent)"></div>

<div class="popup-card">
  <div class="popup-header">
    <span>New Message</span>
    <button type="button" class="close-button" (click)="closePopup(emailForm, editorContent)">✖</button>
  </div>
  <div *ngIf="draft.length > 0" class="draftdiv">
    <button *ngFor="let item of draft" class="btn-item" (click)="selectDraft(item)" [title]="item.subject">
      {{ item.subject }}
      <span class="delete-icon" (click)="deleteDraft(item.id, $event)">&#x2716;</span>
    </button>
  </div>
  <form #emailForm="ngForm" (ngSubmit)="sendEmail($event)">
    <div class="popup-body">
      <label class="to-field">
        <span>To:</span>
        <input [(ngModel)]="emailData.to" name="to" required placeholder="Recipients">
      </label>
      <label class="cc-field">
        <span>Cc:</span>
        <input [(ngModel)]="emailData.cc" name="cc" placeholder="Cc">
      </label>
      <label class="subject-field">
        <input [(ngModel)]="emailData.subject" name="subject" required placeholder="Subject">
      </label>
      <app-drop-down [lists]="option" dropDownWidth="200px" (dataEmit)="selectTemplate($event)" [selectedData]="templatename"></app-drop-down>    
      <div class="email-composer">
        <div class="toolbar">
          <!-- 24AUG24 Toolbar buttons -->
          <button type="button" (click)="undo($event)" title="Undo">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m7.49 12-3.75 3.75m0 0 3.75 3.75m-3.75-3.75h16.5V4.499"/>
            </svg>
          </button>          
          <button type="button" (click)="redo($event)" title="Redo">
            <i class="icon redo-icon"></i>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path  d="m16.49 12 3.75 3.75m0 0-3.75 3.75m3.75-3.75H3.74V4.499" />
            </svg>
            
          </button>
          <div class="custom-select-container">
            <select class="custom-select" (change)="changeFont($event)">
              <option value="Arial">Arial</option>
              <option value="Times New Roman">Times New Roman</option>
              <option value="Courier New">Courier New</option>
            </select>
            <svg class="custom-select-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          <select (change)="changeFontSize($event)">
            <option value="1">Small</option>
            <option value="3">Medium</option>
            <option value="5">Large</option>
          </select>
          <input type="color" style="width:35px;" (change)="changeColor($event)" title="Text Color">
          <button type="button" (click)="format('bold')" title="Bold">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6.75 3.744h-.753v8.25h7.125a4.125 4.125 0 0 0 0-8.25H6.75Zm0 0v.38m0 16.122h6.747a4.5 4.5 0 0 0 0-9.001h-7.5v9h.753Zm0 0v-.37m0-15.751h6a3.75 3.75 0 1 1 0 7.5h-6m0-7.5v7.5m0 0v8.25m0-8.25h6.375a4.125 4.125 0 0 1 0 8.25H6.75m.747-15.38h4.875a3.375 3.375 0 0 1 0 6.75H7.497v-6.75Zm0 7.5h5.25a3.75 3.75 0 0 1 0 7.5h-5.25v-7.5Z" />
            </svg>            
          </button>
          <button type="button" (click)="format('italic')" title="Italic">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5.248 20.246H9.05m0 0h3.696m-3.696 0 5.893-16.502m0 0h-3.697m3.697 0h3.803" />
            </svg> 
          </button>
          <button type="button" (click)="format('underline')" title="Underline">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17.995 3.744v7.5a6 6 0 1 1-12 0v-7.5m-2.25 16.502h16.5" />
            </svg> 
          </button>
          <button type="button" (click)="format('justifyLeft')" title="Align Left">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"/>
            </svg>
          </button>
          <button type="button" (click)="format('justifyCenter')" title="Align Center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>           
          </button>
          <button type="button" (click)="format('justifyRight')" title="Align Right">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25" />
            </svg>  
          </button>
          <button type="button" (click)="format('insertUnorderedList')" title="Bullet List">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"  />
            </svg>      
          </button>
          <button type="button" (click)="format('insertOrderedList')" title="Number List">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path  d="M8.242 5.992h12m-12 6.003H20.24m-12 5.999h12M4.117 7.495v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.577a1.125 1.125 0 1 1 1.591 1.59l-1.83 1.83h2.16M2.99 15.745h1.125a1.125 1.125 0 0 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 0 1 0 2.25H2.99"  />
            </svg>   
          </button>
          <button type="button" (click)="format('indent')" title="Indent More">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 5h15"/>  <!-- Moved up -->
              <path d="M3 12h15"/> <!-- Middle line -->
              <path d="M3 19h15"/> <!-- Moved down -->
              <path d="M3 12l4-4v8l-4-4z"/> <!-- Arrow -->
            </svg>                    
          </button>
          <button type="button" (click)="format('outdent')" title="Indent Less">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M8 5h15"/>  <!-- First horizontal line -->
              <path d="M15 12h15"/> <!-- Second horizontal line -->
              <path d="M8 19h15"/> <!-- Third horizontal line -->
              <path d="M12 12l-4-4v8l4-4z"/> <!-- Arrow pointing left -->
            </svg>                    
          </button>
          <button type="button" (click)="format('formatBlock', 'blockquote')" title="Quote">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
              <path fill="black" d="M7.59,6.12C5.504,6.12,4,7.607,4,9.68c0,2.075,1.504,3.562,3.59,3.562c0,0-0.027,1.065-0.705,2.034c-0.186,0.596,0.146,1.231,0.742,1.418c0.423,0.133,0.869,0.004,1.158-0.396c2.868-2.236,3.385-5.226,3.385-7.766C11.86,7.607,10.356,6.12,7.59,6.12z"/>
              <path fill="black" d="M16.52,6.12c-2.086,0-3.59,1.487-3.59,3.56c0,2.075,1.504,3.562,3.59,3.562c0,0-0.027,1.065-0.705,2.034c-0.186,0.596,0.146,1.231,0.742,1.418c0.423,0.133,0.869,0.004,1.158-0.396c2.868-2.236,3.385-5.226,3.385-7.766C20.1,7.607,18.606,6.12,16.52,6.12z"/>
            </svg>                                            
          </button>
          <button type="button" (click)="format('strikeThrough')" title="Strikethrough">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 12a8.912 8.912 0 0 1-.318-.079c-1.585-.424-2.904-1.247-3.76-2.236-.873-1.009-1.265-2.19-.968-3.301.59-2.2 3.663-3.29 6.863-2.432A8.186 8.186 0 0 1 16.5 5.21M6.42 17.81c.857.99 2.176 1.812 3.761 2.237 3.2.858 6.274-.23 6.863-2.431.233-.868.044-1.779-.465-2.617M3.75 12h16.5"/>
            </svg>      
          </button>
          <button type="button" (click)="format('removeFormat')" title="Remove Formatting">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="black" stroke="black" stroke-width="1">
              <path d="M 4.2890625 5.9726562 L 3.0839844 7.5703125 L 27.777344 26.177734 L 28.980469 24.580078 L 18.027344 16.326172 L 20.285156 10 L 25 10 L 25 11.5 C 25 11.776 25.224 12 25.5 12 L 26.5 12 C 26.776 12 27 11.776 27 11.5 L 27 7.5 C 27 7.224 26.776 7 26.5 7 L 10.5 7 C 10.224 7 10 7.224 10 7.5 L 10 10.277344 L 4.2890625 5.9726562 z M 12 10 L 17.285156 10 L 15.662109 14.544922 L 11.933594 11.734375 C 11.972056 11.663558 12 11.586203 12 11.5 L 12 10 z M 14.253906 18.490234 L 13 22 L 11.5 22 C 11.224 22 11 22.224 11 22.5 L 11 24.5 C 11 24.776 11.224 25 11.5 25 L 16.5 25 C 16.776 25 17 24.776 17 24.5 L 17 22.5 C 17 22.224 16.776 22 16.5 22 L 16 22 L 16.619141 20.265625 L 14.253906 18.490234 z"/>
            </svg>           
          </button>
        </div>

      <div 
        #editorContent
        *ngIf="emailData.content" 
        class="editor"
        contenteditable="true" 
        appContenteditable="emailData.content" 
        [innerHtml]="emailData.content">
      </div>
      </div>

      <div *ngIf="emailData.attachments.length > 0" class="attachments-container">
        <ul>
          <li *ngFor="let file of emailData.attachments; let i = index">
            {{ file.fileName }}
            <button type="button" (click)="removeAttachment(i)" aria-label="Remove" title="Remove">
              ✖
            </button>
          </li>
        </ul>
      </div>      
    </div>

    <div class="popup-footer">
      <div clss="flex-btn">
      <button type="submit" class="send-button">Send</button>
      <button type="button" class="discard-button" (click)="discard()">Discard</button>
    
      <!-- 24AUG24 Button to trigger file input -->
      <button type="button" (click)="fileInput.click()" aria-label="Attach" title="Attach">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"/>
        </svg>
      </button>

      <!-- 24AUG24 Hidden file input -->
      <input type="file" #fileInput (change)="onFileSelected($event)" multiple style="display: none;">

      

      
    
      <!-- <button type="button" (click)="scheduleSend()"  aria-label="Schedule Send" title="Schedule Send">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      </button>  -->
      <!-- 24AUG24 Schedule Send -->
    
      <button type="button" (click)="insertLink()" aria-label="Insert Link" title="Insert Link">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
        </svg>     
      </button> <!-- 24AUG24 Insert Link -->
    
      <button type="button" (click)="insertEmoji()" aria-label="Insert Emoji" title="Insert Emoji">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z" />
        </svg>
      </button> <!-- 24AUG24 Insert Emoji -->
    
      <button type="button" (click)="insertImage()" aria-label="Insert Image" title="Insert Image">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="M21 21l-5-5L5 21" />
        </svg>
      </button> <!-- 24AUG24 Insert Image -->
    
      <button type="button" (click)="insertSignature()" aria-label="Insert Signature" title="Insert Signature">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 10v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <path d="M9 16v-2a4 4 0 1 1 8 0v2" />
          <path d="M3 10h18" />
          <path d="M4 20h16" />
          <path d="M8 14H7" />
        </svg>
      </button> 
    </div>
    <div class="del-btn">
    <button type="button" (click)="deleteDrafticon()" aria-label="Delete Draft" title="Delete Draft">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
      </svg>      
    </button>
  </div>
</div>
  </form>
</div>
